import React, { useEffect, useState } from 'react';

import type { Property } from 'bundles/crm/properties/types';

interface Props {
  autoHeight?: boolean;
  googleMapsApiKey: string;
  height: number;
  property: Pick<Property, 'address' | 'city' | 'state' | 'zip' | 'hasThumbnail' | 'thumbnailUrl'>;
  width: number;
}

export default function PropertyThumbnail({
  googleMapsApiKey,
  height,
  property,
  width,
}: Props) {
  const [imageSrc, setImageSrc] = useState<string | null>(
    property.hasThumbnail ? property.thumbnailUrl : null
  );

  useEffect(() => {
    if (property.hasThumbnail) {
      setImageSrc(property.thumbnailUrl);
      return;
    }

    const { address, city, state, zip } = property;

    if (!imageSrc && address && city && state) {
      const streetviewUrl = new URL('https://maps.googleapis.com/maps/api/streetview');
      streetviewUrl.searchParams.set('key', googleMapsApiKey);
      streetviewUrl.searchParams.set('location', `${address} ${city} ${state} ${zip}`);
      streetviewUrl.searchParams.set('size', `${width}x${height}`);

      const metadataUrl = new URL(streetviewUrl);
      metadataUrl.pathname = `${metadataUrl.pathname}/metadata`;

      fetch(metadataUrl)
        .then(response => response.json())
        .then(({ status }) => {
          if (status === 'OK') {
            setImageSrc(streetviewUrl.toString());
          }
        });
    }
  }, [property]);

  return imageSrc ? (
    <img
      alt={`View of ${property.address}, ${property.city}, ${property.state} ${property.zip}`}
      className="h-100 w-100 object-fit-cover"
      height={height}
      src={imageSrc}
      width={width}
    />
  ) : null;
}
